import { render, staticRenderFns } from "./Verhaal.vue?vue&type=template&id=7e1a27b8&"
import script from "./Verhaal.vue?vue&type=script&lang=js&"
export * from "./Verhaal.vue?vue&type=script&lang=js&"
import style0 from "./Verhaal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports